module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-edu-bg.022040bc.png";